export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पंजीकरण विवरण"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सहेजें"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पुष्टि किया गया"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सार्वजनिक"])}
}